import React, { useState, useEffect, useContext, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import {
    Collapse,
    Row,
    Col,
    Card,
    Statistic,
    Switch,
    Spin,
    Alert,
    Modal,
    Button,
    Checkbox
} from 'antd';
import QQPlotChart from './QQPlotChart';

const AutoregressionChart = (props) => {
    const { Panel } = Collapse;
    let scatterplotData = props.getAnalysisRes[props.scatterType];
    let headerTitle = 'Scatterplot';
    if(props.scatterType == 'robust_scatterplot') {
        headerTitle = 'Robust Scatterplot';
    } else if(props.scatterType == 'weighted_scatterplot') {
        headerTitle = 'Weighted Scatterplot';
    }


    let scatterplotOptions = {
        chart: {
            marginRight: 30,
            marginLeft: 77,
            marginTop: 20,
            renderTo: 'chart-container',
            zoomType: 'xy',
            height: 400
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true
        },
        credits: {
            enabled: false
        },
        title: {
            text: undefined,
            style: { fontSize: '11px' }
        },
        subtitle: {
            text: undefined,
            style: { fontSize: '10px' }
        },
        xAxis: [
            {
                endOnTick: true,
                //tickInterval: 1,
                tickLength: 0,
                lineWidth: 0,
                labels: {
                    enabled: true,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '11px'
                    }
                },
                title: {
                    text: scatterplotData.x_display_name,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '14px'
                    }
                }
            }
        ],
        yAxis: [
            {
                // Primary yAxis
                //minorTickInterval: 'auto',
                labels: {
                    style: { fontSize: '11px' }
                },
                title: {
                    text: scatterplotData.y_display_name,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '14px'
                    }
                }
            }
        ],
        navigation: {
            buttonOptions: {
                align: 'right',
                backgroundColor: '#ffffff',
                borderColor: '#B0B0B0',
                borderRadius: 3,
                borderWidth: 1,
                enabled: true,
                height: 20,
                hoverBorderColor: '#909090',
                hoverSymbolFill: '#81A7CF',
                hoverSymbolStroke: '#4572A5',
                symbolFill: '#E0E0E0',
                symbolSize: 12,
                symbolStroke: '#A0A0A0',
                symbolStrokeWidth: 1,
                symbolX: 11.5,
                symbolY: 10.5,
                verticalAlign: 'top',
                width: 24,
                y: 10
            },
            menuStyle: {
                border: '1px solid #A0A0A0',
                background: '#FFFFFF'
            },
            menuItemStyle: {
                padding: '0 5px',
                background: 'NONE',
                color: '#303030'
            },
            menuItemHoverStyle: {
                background: '#4572A5',
                color: '#FFFFFF'
            }
        },
        tooltip: {
            useHTML: true,
            shape: 'square',
            shared: false,
            borderRadius: 0,
            borderWidth: 0,
            shadow: false,
            enabled: true,
            backgroundColor: 'none',
            formatter: function () {
                if (this.point.company_id) {
                    var string = `<div class="tooltipContainer">Company ID: ${this.point.company_id}<br>FY: ${this.point.fy}<br>${this.x}:${this.y}</div>`;
                } else {
                    var string = `<div class="tooltipContainer">${this.x.toFixed(
                        4
                    )}:${this.y.toFixed(4)}</div>`;
                }
                return string;
            }
        },
        plotOptions: { scatter: { marker: { radius: 2 } } },

        legend: {
            enabled: false,
            layout: 'vertical',
            align: 'left',
            x: 10,
            verticalAlign: 'top',
            y: 0,
            floating: true,
            backgroundColor: '#FFFFFF'
        },
        series: [
            {
                name: 'seriesOneName1',
                color: '#407CB1',
                type: 'scatter',
                yAxis: 0,
                // data: scatterDataIndex,
                data: scatterplotData.scatter,
                turboThreshold: 50000
            },

            {
                name: 'seriesTwoName1',
                type: 'spline',
                color: '#60091D',
                yAxis: 0,
                // data: scatter_data['chart']['fitted'],
                data: scatterplotData.scatter_line,
                marker: { enabled: false },
                turboThreshold: 50000
            }
        ]
    };

    // Tables

    let scatterplotTable = scatterplotData.reg_stat;

    // let regHeaders = [];
    let scattRows = [];

    for (let i = 0; i < Object.keys(scatterplotTable).length; i++) {
        scattRows.push(Object.values(scatterplotTable)[i]);
    }

    // let newScattRows = scattRows.map((item) => {
    //     let fixedValue = item.value;

    //     if (typeof fixedValue === 'number') {
    //         fixedValue = fixedValue.toFixed(4);
    //     }

    //     return (
    //         <Col
    //             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //             style={{ marginTop: 10 }}
    //         >
    //             <Card>
    //                 <Statistic
    //                     key={item.display_name}
    //                     title={item.display_name}
    //                     value={fixedValue}
    //                     // precision={2}
    //                     // valueStyle={{ color: '#60091d' }}
    //                     // prefix={<ArrowUpOutlined />}
    //                     // suffix="%"
    //                 />
    //             </Card>
    //         </Col>
    //     );
    // });

    // let statScattTable = (
    //     <>
    //         <div>
    //             {/* <h3
    //                 style={{
    //                     fontFamily: 'Roboto Medium',
    //                     fontSize: '14px',
    //                     lineHeight: '18px',
    //                     color: '#407CB1'
    //                 }}
    //             >
    //                 Statistics
    //             </h3> */}
    //             <Row className="statistics-row-box" gutter={16}>
    //                 {newScattRows}
    //             </Row>
    //         </div>
    //     </>
    // );

    let newStatsScattRows2 = scattRows.map((item) => {
        let fixedValue = item.value;
        return (
            <tr>
                <td className="title">{item.display_name}</td>
                <td className="value">{fixedValue}</td>
            </tr>
        );
    });

    let statScattTable2 = (
        <>
            <div key="12341">
                {/* <Row className="statistics-row-box" gutter={16}> */}
                <div className="statistics-row-box">
                    <div className="table-box-fullproject-view">
                        <h3
                            style={{
                                marginTop: '10px'
                                // fontFamily: 'Roboto Medium'
                            }}
                        >
                            Statistics
                        </h3>
                        <table className="table-table">
                            <tbody>{newStatsScattRows2}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    // ScatterplotStdResid
    let scattStdResidData = scatterplotData.resid_stat;

    let scattStdResidHeaders = [];
    let scattStdResidRows = [];

    for (let i = 0; i < Object.keys(scattStdResidData).length; i++) {
        scattStdResidHeaders.push(
            Object.keys(scattStdResidData)[i].charAt(0).toUpperCase() +
                Object.keys(scattStdResidData)[i].slice(1)
        );
    }

    for (let j = 0; j < Object.keys(scattStdResidData).length; j++) {
        scattStdResidRows.push(Object.values(scattStdResidData)[j].toFixed(4));
    }

    let newScattStdResidHeaders = scattStdResidHeaders.map((item) => {
        return <th>{item}</th>;
    });

    let newScattStdResidRows = scattStdResidRows.map((item) => {
        return <td>{item}</td>;
    });

    let scattStdResidRowsTable = (
        <>
            <div className="table-box-fullproject">
                <h3>Standardized Residuals</h3>
                <table className="table-regression first-row-bold">
                    <thead>
                        <tr>{newScattStdResidHeaders}</tr>
                    </thead>
                    <tbody>
                        <tr>{newScattStdResidRows}</tr>
                    </tbody>
                </table>
            </div>
        </>
    );

    // scattstdErrData

    let scattStdErrData = scatterplotData.std_err;
    let scattStdErrHeaders = ['', 'Coeff', 'Std Error', 't-Stat', 'Vif'];

    let newScattStdErrHeaders = scattStdErrHeaders.map((item) => {
        return <th key={item}>{item}</th>;
    });

    let scattDataRows = Object.values(scattStdErrData);

    let scattTableRows = [];

    for (let i = 0; i < scattDataRows.length; i++) {
        let dr = scattDataRows[i];

        let coeff = dr.coeff;
        let std_err = dr.std_err;
        let t_stat = dr.t_stat;
        let vif = typeof dr.vif == 'string' ? '-' : dr.vif;

        scattTableRows.push(
            <tr>
                <td>{dr.display_name}</td>
                <td>{coeff}</td>
                <td>{std_err}</td>
                <td>{t_stat}</td>
                <td>{vif}</td>
            </tr>
        );
    }

    let scattStdErrRows = [];

    let scattStdErrTable = (
        <>
            <div className="table-box-fullproject">
                <h3>Ordinary Std Error</h3>
                <table className="table-regression">
                    <thead>
                        <tr>{newScattStdErrHeaders}</tr>
                    </thead>
                    <tbody>{scattTableRows}</tbody>
                </table>
            </div>
        </>
    );

    // scatterplotNwStdErr

    let scatterNwStdErrUS = scatterplotData.nw_std_err;

    let scatterNwStdErrHeaders = ['', 'Coeff', 'std Error', 't-Stat', 'Vif'];

    let newScatterNwStdErrHeaders = scatterNwStdErrHeaders.map((item) => {
        return <th key={item}>{item}</th>;
    });

    let scatterNwDataRows = Object.values(scatterNwStdErrUS);

    let scatterNwTableRows = [];

    for (let i = 0; i < scatterNwDataRows.length; i++) {
        let dr = scatterNwDataRows[i];

        let coeff = dr.coeff;
        let std_err = dr.std_err;
        let t_stat = dr.t_stat;
        let vif = typeof dr.vif == 'string' ? '-' : dr.vif;

        scatterNwTableRows.push(
            <tr>
                <td>{dr.display_name}</td>
                <td>{coeff}</td>
                <td>{std_err}</td>
                <td>{t_stat}</td>
                <td>{vif}</td>
            </tr>
        );
    }

    let scatterNwStdErrRows = [];
    let nwStdErrLabel = props.scatterType === 'weighted_scatterplot' ? 'HC3 Std Error' : 'Newey-West Std Error';

    let scatterNwStdErrTable = (
        <>
            <div className="table-box-fullproject">
                <h3>{nwStdErrLabel}</h3>
                <table className="table-regression">
                    <thead>
                        <tr>{newScatterNwStdErrHeaders}</tr>
                    </thead>
                    <tbody>{scatterNwTableRows}</tbody>
                </table>
            </div>
        </>
    );

    // scatterplot Confidence Intervals

    let confidenceIntervalsTable;
    let scatterplotConfInt;

    if(scatterplotData.hasOwnProperty('conf_intervals')){


        scatterplotConfInt = scatterplotData.conf_intervals;
        let confidenceIntervalsRows = []
        confidenceIntervalsRows.push(<tr><td></td><td className='ff-rb'>Lower</td><td className='ff-rb'>Upper</td><td className='ff-rb'>t-Stat</td></tr>)


        for(let i = 0; i < Object.keys(scatterplotConfInt).length; i++) {

            let level50 = 'Level 50%';
            let level68 = 'Level 68%';
            let level90 = 'Level 90%';
            let level95 = 'Level 95%';

            if(Object.keys(scatterplotConfInt)[i] == 'level50') {
                confidenceIntervalsRows.push(<tr><td className='ff-rb'>{level50}</td><td>{Object.values(scatterplotConfInt)[i].lower}</td><td>{Object.values(scatterplotConfInt)[i].upper}</td><td>{Object.values(scatterplotConfInt)[i].t_stat}</td></tr>)
            }
            if(Object.keys(scatterplotConfInt)[i] == 'level68') {
                confidenceIntervalsRows.push(<tr><td className='ff-rb'>{level68}</td><td>{Object.values(scatterplotConfInt)[i].lower}</td><td>{Object.values(scatterplotConfInt)[i].upper}</td><td>{Object.values(scatterplotConfInt)[i].t_stat}</td></tr>)
            }
            if(Object.keys(scatterplotConfInt)[i] == 'level90') {
                confidenceIntervalsRows.push(<tr><td className='ff-rb'>{level90}</td><td>{Object.values(scatterplotConfInt)[i].lower}</td><td>{Object.values(scatterplotConfInt)[i].upper}</td><td>{Object.values(scatterplotConfInt)[i].t_stat}</td></tr>)
            }
            if(Object.keys(scatterplotConfInt)[i] == 'level95') {
                confidenceIntervalsRows.push(<tr><td className='ff-rb'>{level95}</td><td>{Object.values(scatterplotConfInt)[i].lower}</td><td>{Object.values(scatterplotConfInt)[i].upper}</td><td>{Object.values(scatterplotConfInt)[i].t_stat}</td></tr>)
            }

            {/* confidenceIntervalsRows.push(<tr><td>{Object.keys(scatterplotConfInt)[i]}</td><td>{Object.values(scatterplotConfInt)[i].lower}</td><td>{Object.values(scatterplotConfInt)[i].upper}</td><td>{Object.values(scatterplotConfInt)[i].t_stat}</td></tr>) */}
        }


        confidenceIntervalsTable = (
            <>
                <div className="table-box-fullproject">
                    <h3>Newey-West Confidence Intervals</h3>
                    <table className="table-regression">
                        {/* <thead>
                            <tr>{newScatterNwStdErrHeaders}</tr>
                        </thead> */}
                        <tbody>{confidenceIntervalsRows}</tbody>
                    </table>
                </div>
            </>
        );
    }


    let fullStats = (
        <div ref={props.forwardedRefStatistics}>
        {statScattTable2}
            {scattStdResidRowsTable}
            {scattStdErrTable}
            {scatterNwStdErrTable}
            {scatterplotData.hasOwnProperty('conf_intervals') ? confidenceIntervalsTable : null}
        </div>
    );

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={headerTitle}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={scatterplotOptions}
                        ref={props.forwardedRef}
                    />

                    {/* Standardized Residuals QQ Plot */}
                    {scatterplotData.standardized_residuals_qq_plot && (
                        <QQPlotChart
                            getAnalysisRes={scatterplotData}
                            forwardedRefNormal={props.forwardedRefQQPlotNormal}
                            forwardedRefLognormal={props.forwardedRefQQPlotLognormal}
                            forwardedRefBurr12={props.forwardedRefQQPlotBurr12}
                        />
                    )}

                    {fullStats}
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(AutoregressionChart);
